__turbopack_context__.v({
  "colorCircle": "qoVwpa_colorCircle",
  "colorGrid": "qoVwpa_colorGrid",
  "container": "qoVwpa_container",
  "label": "qoVwpa_label",
});
